import { render, staticRenderFns } from "./EmpFpDetails.vue?vue&type=template&id=a7fac6ce&scoped=true"
import script from "./EmpFpDetails.vue?vue&type=script&lang=js"
export * from "./EmpFpDetails.vue?vue&type=script&lang=js"
import style0 from "./EmpFpDetails.vue?vue&type=style&index=0&id=a7fac6ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7fac6ce",
  null
  
)

export default component.exports